import { getCurrentInstance, computed, ref, Ref } from 'vue';
import { NoteContentType } from '@/types/notes';
import useNotes from '@/utilities/composables/useNotes';

export default function useNoteContent(noteId: Ref) {
  const _this = getCurrentInstance()!.proxy as any;
  if (!_this) return;

  const { getAiNote } = useNotes?.() || {};

  const noteTemplateId = ref('');

  const note = computed(() => _this.$store.getters.getNotes[noteId.value] || {});

  const noteContent = computed(() => {
    if (!noteTemplateId.value) return note.value[NoteContentType.UserNotes] || '';

    const aiNote = getAiNote?.(noteId.value, noteTemplateId.value);
    return aiNote?.content || '';
  });

  const noteTitle = computed(() => note.value?.title || '');

  return {
    noteTemplateId,
    note,
    noteTitle,
    noteContent,
  };
}
